module.exports = __webpack_public_path__ + "static/media/GO_P_clusters_plot.82765aff.png";